export default {
  orderexacutiverate: {
    day: '天',
    confirmTime: '确认等待时间',
    receivingTime: '收货等待时间',
    teliveryTime: '发货等待时间',
    implementationRate: '各供应商执行率',
    totalImplementationRate: '订单总执行率',
    excellent: '优秀',
    commonly: '一般',
    poor: '较差',
    orderexacutiverate: '订单执行率',
    tableTitle: '各供应商执行率表格',
    supplierName: '供应商',
    purOfficeName: '采购中心',
    waitConfirmTime: '确认等待时间',
    shipWaitTime: '发货等待时间',
    receiptWaitTime: '收货等待时间',
    totalTime: '总等待时间',
    barTitle: '各供应商执行率',
    startPurchaseDate: '订单日期-起',
    endPurchaseDate: '订单日期-止',
    classifyNo: '采购中心',
    purchaseUnitNo: '供应商分类',
    fileName: '订单执行率表'
  },
  orderprice: {
    price: '价格',
    barTitle: '订单价格分析',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    supplierName: '供应商',
    purOfficeName: '采购中心',
    unitPrice: '含税单价',
    batchPurQty: '订单数量',
    dateStart: '订单日期-起',
    dateEnd: '订单日期-止',
    purchaseUnitNo: '采购中心',
    officeNo: '供应商',
    fileName: '订单价格表',
    exportName: '查询条件'
  },
  supplyratiocompare: {
    searchPlaceholder: '请输入订单单号查询',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    supOfficeName: '供应商',
    purchaseDate: '订单日期',
    purchaseNo: '订单单号',
    purchaseSeq: '项次',
    purchasePhaseSeq: '项序',
    actualPurchaseRate: '订单供货比例',
    standardPurchaseRate: '标准供货比例',
    difference: '差异',
    startPurchaseDate: '订单日期-起',
    endPurchaseDate: '订单日期-止',
    all: '全部',
    fileName: '供应商比例实际与标准对比表',
    type: ['供货比例实际与标准对比', '平均供货比例实际与标准对比']
  }
}
